import { ApplicationError } from "@design-system";
import { ApolloError } from "@apollo/client";
import { translateGraphQLErrors } from "./graphql-errors";

export function translateApolloError(error: ApolloError, message?: string): ApplicationError {
  const { message: apolloErrorMessage, graphQLErrors, networkError } = error;
  console.log(`Apollo Error: "${apolloErrorMessage}"`, error);
  if (networkError) {
    return new ApplicationError("SERVER_ERROR", message);
  } else if (graphQLErrors.length > 0) {
    return translateGraphQLErrors(graphQLErrors);
  }
  return new ApplicationError("UNKNOWN_ERROR", message);
}
